import type { StreamingType } from "@spwn/types";

/**
 * この端末で低遅延モードON時に使う再生方式。
 * "HLS" は低遅延手段なし (常に default の通常HLSを再生する)。
 */
export type PlayMode = "HLS" | "IVS" | "LLHLS";

/**
 * 配信データ・feature flag・端末能力から再生方式を決める。
 * LL-HLS は MMS が使える iOS 端末かつ llhls フラグ有効のときに使い、
 * 使えなければ IVS が再生可能なら IVS にフォールバックする。
 */
export const derivePlayMode = ({
  streamingType,
  hasLLHLSData,
  isLLHLSEnabled,
  canUseMMS,
  isIVSPlayable,
}: {
  streamingType: StreamingType;
  /** cookies に LL_HLS キーがあるか */
  hasLLHLSData: boolean;
  isLLHLSEnabled: boolean;
  /** iOS 端末で ManagedMediaSource が使えるか */
  canUseMMS: boolean;
  /** IVS が再生可能か (IVS Player 対応 かつ Live かつ cookies に LL キーあり) */
  isIVSPlayable: boolean;
}): PlayMode => {
  if (streamingType !== "Live") {
    return "HLS";
  }
  if (hasLLHLSData && isLLHLSEnabled && canUseMMS) {
    return "LLHLS";
  }
  if (isIVSPlayable) {
    return "IVS";
  }
  return "HLS";
};

/**
 * 低遅延トグルの初期状態。IVS はデフォルトON。
 * MMS の挙動が不安定なため、LL-HLS はデフォルトOFF。
 */
export const isLowLatencyDefaultEnabled = (mode: PlayMode): boolean => {
  return mode === "IVS";
};
